/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Tables_P3Inputs */

const en_wc_tut_tables_p3 = /** @type {(inputs: Wc_Tut_Tables_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On the Layout tab set margins, orientation, paper size and columns, and insert page or section breaks. Headers, footers and page numbers live on the Insert tab.`)
};

/**
* | output |
* | --- |
* | "On the Layout tab set margins, orientation, paper size and columns, and insert page or section breaks. Headers, footers and page numbers live on the Insert tab." |
*
* @param {Wc_Tut_Tables_P3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_tables_p3 = /** @type {((inputs?: Wc_Tut_Tables_P3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Tables_P3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_tables_p3(inputs)
});
export { wc_tut_tables_p3 as "wc.tut.tables.p3" }